import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {Auth} from '../../auth/auth.service';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Lecture} from '../classes/lecture';
import {Series} from '../classes/series';

@Component({
    selector: 'kkk-lectures',
    templateUrl: './lectures.component.html',
    styleUrls: ['./lectures.component.scss']
})
export class LecturesComponent implements OnInit, OnDestroy {

    public series: Series;
    public lectures: Lecture[];

    private subscriptions: Subscription[] = [];

    constructor(
        public auth: Auth,
        private route: ActivatedRoute,
        private router: Router,
        private _breadcrumbs: BreadcrumbsService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s && s.unsubscribe());
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Felvételek', instructions: ['/felvetelek']})
            .add({name: 'Sorozatok', instructions: ['/felvetelek/sorozatok']});
        this.subscriptions.push(this.route.params.subscribe(
            params => this.loadSeries(params['id'])
        ));
    }

    back() {
        return this.router.navigate(['/felvetelek/sorozatok']);
    }

    removeLecture(lecture: Lecture): void {
        if (confirm(`Biztosan törölni szeretnéd? ${lecture.preacher}, ${lecture.number}`)) {
            this.subscriptions.push(
                lecture.remove().subscribe(
                    () => {
                        this.lectures = this.lectures.filter(s => s.id !== lecture.id);
                        this._messenger.showSuccess('A sorozat előadás sikeresen törölve lett');
                    },
                    this._messenger.handleError
                )
            );
        }
    }

    private loadSeries(seriesId) {
        this.series = Series.loadForNext();
        if (this.series) {
            this.loadLectures();
            return;
        }
        this.subscriptions.push(
            new Series().find(seriesId).subscribe(
                series => {
                    this.series = series;
                    this.loadLectures();
                },
                e => {
                    this._messenger.handleError(e);
                    this.series = new Series().init({title: 'Hiba!', when: 'Nincs sorozat ezzel az azonosítóval!'});
                    this.lectures = [];
                }
            )
        );
    }

    private loadLectures() {
        this._breadcrumbs.add({name: `${this.series.title} (${this.series.when})`});
        this.subscriptions.push(
            new Lecture().addParent(this.series).all().subscribe(
                lectures => this.lectures = lectures.map(l => l.addParent(this.series)),
                e => {
                    this._messenger.handleError(e);
                    this.lectures = [];
                }
            )
        );
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/lectures/lectures.component.ts